import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ApiError } from "../types";

const API_URL = import.meta.env.VITE_API_URL;

// Types for Mint Batch
interface TokenAmount {
	tokenId: number;
	amount: number;
}

interface TransferBatchRequestDto {
	from: string;
	to: string;
	collectionAddress: string;
	tokenAmounts: TokenAmount[];
}

interface TransferRequestDto {
	from: string;
	to: string;
	collectionAddress: string;
	tokenId: string;
}

interface TransferResponseDto {
	transactionHash: string;
}

export const useTransferNFTBatchMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<TransferResponseDto, ApiError, TransferBatchRequestDto>({
		mutationFn: async (data) => {
			const response = await fetch(`${API_URL}/inventory/transfer-batch`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});
			toast.success("Transfered successfully");
		},
		onError: (error) => {
			toast.error(error.message.slice(0, 300));
		},
	});
};

export const useTransferNFTMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<TransferResponseDto, ApiError, TransferRequestDto>({
		mutationFn: async (data) => {
			const response = await fetch(`${API_URL}/inventory/transfer`, {
				method: "POST",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});

			if (!response.ok) {
				const error = await response.json();
				throw error;
			}

			return response.json();
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["nfts"],
			});

			toast.success("Transfered successfully");
		},
		onError: (error) => {
			toast.error(error.message.slice(0, 300));
		},
	});
};
